import React, {Component} from "react"
import {Link} from 'react-router'

class Breadcrumb extends Component {

  render() {

    const data = this.props.data || []


    return (
      <ol className="breadcrumb">

        { data.map((it, index)=> {
          if (index < data.length - 1) {
            if(it.link){

              return (
                <li>
                  <Link to={it.link}>{it.name}</Link>
                </li>
              )
            }else{
              return (
                <li>
                  {it.name}
                </li>
              )
            }

          } else {
            return (
              <li className="active">
                <strong>{it.name}</strong>
              </li>
            )
          }
        })
        }

      </ol>
    )
  }
}

export default Breadcrumb



// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js